/*
 * ELTANE — "Notify me" for sold-out products
 *
 * Renders in place of Add to cart / Buy it now when a product is unavailable
 * (see snippets/eltane-notify-me.liquid, rendered from buy-buttons.liquid).
 * Posts { email, product_id, variant_id, product_title, product_url } to the
 * Flask recommendation API's POST /api/notify-me. The backend stores it and
 * emails the visitor once a Shopify webhook reports the product back in
 * stock — this file's job ends at "saved successfully."
 */
(function () {
  'use strict';

  function init(root) {
    (root || document).querySelectorAll('[data-notify-me]').forEach(function (block) {
      if (block.dataset.notifyBound === 'true') return;
      block.dataset.notifyBound = 'true';

      var apiBase = (block.getAttribute('data-api-base') || '').replace(/\/+$/, '');
      var apiSecretKey = block.getAttribute('data-api-secret-key') || '';
      var productId = block.getAttribute('data-product-id') || '';
      var variantId = block.getAttribute('data-variant-id') || '';
      var productTitle = block.getAttribute('data-product-title') || '';
      var productUrl = block.getAttribute('data-product-url') || '';

      var openButton = block.querySelector('[data-notify-open]');
      var form = block.querySelector('[data-notify-form]');
      var emailInput = block.querySelector('[data-notify-email]');
      var submitButton = block.querySelector('[data-notify-submit]');
      var status = block.querySelector('[data-notify-status]');

      function report(message) {
        if (!status) return;
        status.textContent = message;
        status.hidden = !message;
      }

      if (openButton && form) {
        openButton.addEventListener('click', function () {
          openButton.hidden = true;
          form.hidden = false;
          if (emailInput) emailInput.focus();
        });
      }

      if (!form || !submitButton) return;

      /* Plain click, not a form submit - see eltane-notify-me.liquid for why
         this deliberately isn't a <form>: it lives inside Shopify's own
         product <form>, and a type="submit" button there submits THAT form
         (add-to-cart) instead, which crashes on a sold-out product. */
      function submit() {
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email || (emailInput && emailInput.checkValidity && !emailInput.checkValidity())) {
          report('Enter a valid email to continue.');
          return;
        }
        if (!apiBase) {
          report('Notifications are not configured for this store yet.');
          return;
        }

        submitButton.disabled = true;
        report('Saving…');

        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        if (apiSecretKey) headers['X-Api-Key'] = apiSecretKey;

        window
          .fetch(apiBase + '/api/notify-me', {
            method: 'POST',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify({
              email: email,
              product_id: productId,
              variant_id: variantId,
              product_title: productTitle,
              product_url: productUrl
            })
          })
          .then(function (response) {
            return response.json().then(function (body) {
              if (!response.ok) throw new Error(body.error || 'Could not save your request.');
              return body;
            });
          })
          .then(function () {
            form.hidden = true;
            report("You're on the list — we'll email you the moment it's back.");
          })
          .catch(function (error) {
            submitButton.disabled = false;
            report(error.message || 'Could not save your request. Try again.');
          });
      }

      submitButton.addEventListener('click', submit);
      if (emailInput) {
        emailInput.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          submit();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
